var map = {
	"./ActivityLevel.png": "./src/assets/image/ActivityLevel.png",
	"./BodyType.png": "./src/assets/image/BodyType.png",
	"./FitnessLevel.png": "./src/assets/image/FitnessLevel.png",
	"./START.png": "./src/assets/image/START.png",
	"./Vector_left.png": "./src/assets/image/Vector_left.png",
	"./Vector_right.png": "./src/assets/image/Vector_right.png",
	"./about1.png": "./src/assets/image/about1.png",
	"./about2.png": "./src/assets/image/about2.png",
	"./about3.png": "./src/assets/image/about3.png",
	"./about_icon1.png": "./src/assets/image/about_icon1.png",
	"./about_icon2.png": "./src/assets/image/about_icon2.png",
	"./about_icon3.png": "./src/assets/image/about_icon3.png",
	"./apple_logo.png": "./src/assets/image/apple_logo.png",
	"./ask1.png": "./src/assets/image/ask1.png",
	"./ask2.png": "./src/assets/image/ask2.png",
	"./ask3.png": "./src/assets/image/ask3.png",
	"./avatar_1.png": "./src/assets/image/avatar_1.png",
	"./avatar_2.png": "./src/assets/image/avatar_2.png",
	"./avatar_3.png": "./src/assets/image/avatar_3.png",
	"./base_code.png": "./src/assets/image/base_code.png",
	"./bmi01.png": "./src/assets/image/bmi01.png",
	"./bmi02.png": "./src/assets/image/bmi02.png",
	"./bmi03.png": "./src/assets/image/bmi03.png",
	"./chairYogaPlans.png": "./src/assets/image/chairYogaPlans.png",
	"./chairYogaPlans1.png": "./src/assets/image/chairYogaPlans1.png",
	"./chairYogaPlans2.png": "./src/assets/image/chairYogaPlans2.png",
	"./chairYogaPlans3.png": "./src/assets/image/chairYogaPlans3.png",
	"./chart_bg.png": "./src/assets/image/chart_bg.png",
	"./circle_icon.png": "./src/assets/image/circle_icon.png",
	"./clock-o.png": "./src/assets/image/clock-o.png",
	"./code.png": "./src/assets/image/code.png",
	"./credit-card-check.png": "./src/assets/image/credit-card-check.png",
	"./en/code1.png": "./src/assets/image/en/code1.png",
	"./en/code2.png": "./src/assets/image/en/code2.png",
	"./en/frame.png": "./src/assets/image/en/frame.png",
	"./en/frame_2.png": "./src/assets/image/en/frame_2.png",
	"./en/img_about_us_photo1.png": "./src/assets/image/en/img_about_us_photo1.png",
	"./en/img_about_us_photo2.png": "./src/assets/image/en/img_about_us_photo2.png",
	"./en/img_reviews_top.png": "./src/assets/image/en/img_reviews_top.png",
	"./en/know_chart.png": "./src/assets/image/en/know_chart.png",
	"./en/logo.png": "./src/assets/image/en/logo.png",
	"./en/logo_home.png": "./src/assets/image/en/logo_home.png",
	"./en/logo_other.png": "./src/assets/image/en/logo_other.png",
	"./en/visa.png": "./src/assets/image/en/visa.png",
	"./flag.png": "./src/assets/image/flag.png",
	"./flat.png": "./src/assets/image/flat.png",
	"./frame.png": "./src/assets/image/frame.png",
	"./gift.png": "./src/assets/image/gift.png",
	"./home_loginout.png": "./src/assets/image/home_loginout.png",
	"./icon.png": "./src/assets/image/icon.png",
	"./icon_0.png": "./src/assets/image/icon_0.png",
	"./icon_1.png": "./src/assets/image/icon_1.png",
	"./icon_2.png": "./src/assets/image/icon_2.png",
	"./icon_3.png": "./src/assets/image/icon_3.png",
	"./icon_4.png": "./src/assets/image/icon_4.png",
	"./icon_target.png": "./src/assets/image/icon_target.png",
	"./icon_weight.png": "./src/assets/image/icon_weight.png",
	"./img_paywall_result1.png": "./src/assets/image/img_paywall_result1.png",
	"./img_paywall_result2.png": "./src/assets/image/img_paywall_result2.png",
	"./img_paywall_result3.png": "./src/assets/image/img_paywall_result3.png",
	"./includes1.png": "./src/assets/image/includes1.png",
	"./includes2.png": "./src/assets/image/includes2.png",
	"./includes3.png": "./src/assets/image/includes3.png",
	"./includes4.png": "./src/assets/image/includes4.png",
	"./includes5.png": "./src/assets/image/includes5.png",
	"./includes6.png": "./src/assets/image/includes6.png",
	"./includes7.png": "./src/assets/image/includes7.png",
	"./includes8.png": "./src/assets/image/includes8.png",
	"./lock.png": "./src/assets/image/lock.png",
	"./logo.png": "./src/assets/image/logo.png",
	"./logout.png": "./src/assets/image/logout.png",
	"./new_code.png": "./src/assets/image/new_code.png",
	"./other_loginout.png": "./src/assets/image/other_loginout.png",
	"./payment_logo.png": "./src/assets/image/payment_logo.png",
	"./payment_logo_active.png": "./src/assets/image/payment_logo_active.png",
	"./paypal.png": "./src/assets/image/paypal.png",
	"./paywall_swiper.png": "./src/assets/image/paywall_swiper.png",
	"./paywall_swiper1.png": "./src/assets/image/paywall_swiper1.png",
	"./paywall_swiper2.png": "./src/assets/image/paywall_swiper2.png",
	"./paywall_swiper3.png": "./src/assets/image/paywall_swiper3.png",
	"./plan1.png": "./src/assets/image/plan1.png",
	"./plan2.png": "./src/assets/image/plan2.png",
	"./plan3.png": "./src/assets/image/plan3.png",
	"./plan4.png": "./src/assets/image/plan4.png",
	"./plan_date.png": "./src/assets/image/plan_date.png",
	"./plan_preview1_1.png": "./src/assets/image/plan_preview1_1.png",
	"./plan_preview1_2.png": "./src/assets/image/plan_preview1_2.png",
	"./plan_preview1_3.png": "./src/assets/image/plan_preview1_3.png",
	"./plan_preview1_4.png": "./src/assets/image/plan_preview1_4.png",
	"./plan_preview2_1.png": "./src/assets/image/plan_preview2_1.png",
	"./plan_preview2_2.png": "./src/assets/image/plan_preview2_2.png",
	"./plan_preview2_3.png": "./src/assets/image/plan_preview2_3.png",
	"./plan_preview2_4.png": "./src/assets/image/plan_preview2_4.png",
	"./plan_preview3_1.png": "./src/assets/image/plan_preview3_1.png",
	"./plan_preview3_2.png": "./src/assets/image/plan_preview3_2.png",
	"./plan_preview3_3.png": "./src/assets/image/plan_preview3_3.png",
	"./plan_preview3_4.png": "./src/assets/image/plan_preview3_4.png",
	"./premium_icon.png": "./src/assets/image/premium_icon.png",
	"./price_bg.png": "./src/assets/image/price_bg.png",
	"./ruler.png": "./src/assets/image/ruler.png",
	"./stripe.png": "./src/assets/image/stripe.png",
	"./target1.png": "./src/assets/image/target1.png",
	"./target2.png": "./src/assets/image/target2.png",
	"./target3.png": "./src/assets/image/target3.png",
	"./target4.png": "./src/assets/image/target4.png",
	"./target5.png": "./src/assets/image/target5.png",
	"./target6.png": "./src/assets/image/target6.png",
	"./target7.png": "./src/assets/image/target7.png",
	"./template/activities-image-1.png": "./src/assets/image/template/activities-image-1.png",
	"./template/activities-image-2.png": "./src/assets/image/template/activities-image-2.png",
	"./template/activities-image-3.png": "./src/assets/image/template/activities-image-3.png",
	"./template/activities-image-4.png": "./src/assets/image/template/activities-image-4.png",
	"./template/activities-image-5.png": "./src/assets/image/template/activities-image-5.png",
	"./template/activities-image-6.png": "./src/assets/image/template/activities-image-6.png",
	"./template/activityLevel-image-1.png": "./src/assets/image/template/activityLevel-image-1.png",
	"./template/activityLevel-image-2.png": "./src/assets/image/template/activityLevel-image-2.png",
	"./template/activityLevel-image-3.png": "./src/assets/image/template/activityLevel-image-3.png",
	"./template/activityLevel-image-4.png": "./src/assets/image/template/activityLevel-image-4.png",
	"./template/age-image-1.png": "./src/assets/image/template/age-image-1.png",
	"./template/age-image-1.webp": "./src/assets/image/template/age-image-1.webp",
	"./template/age-image-2.png": "./src/assets/image/template/age-image-2.png",
	"./template/age-image-2.webp": "./src/assets/image/template/age-image-2.webp",
	"./template/age-image-3.png": "./src/assets/image/template/age-image-3.png",
	"./template/age-image-3.webp": "./src/assets/image/template/age-image-3.webp",
	"./template/age-image-4.png": "./src/assets/image/template/age-image-4.png",
	"./template/age-image-4.webp": "./src/assets/image/template/age-image-4.webp",
	"./template/age_group_1_1.webp": "./src/assets/image/template/age_group_1_1.webp",
	"./template/age_group_1_2.webp": "./src/assets/image/template/age_group_1_2.webp",
	"./template/age_group_1_3.webp": "./src/assets/image/template/age_group_1_3.webp",
	"./template/age_group_1_4.webp": "./src/assets/image/template/age_group_1_4.webp",
	"./template/age_group_2_1.webp": "./src/assets/image/template/age_group_2_1.webp",
	"./template/age_group_2_2.webp": "./src/assets/image/template/age_group_2_2.webp",
	"./template/age_group_2_3.webp": "./src/assets/image/template/age_group_2_3.webp",
	"./template/age_group_2_4.webp": "./src/assets/image/template/age_group_2_4.webp",
	"./template/age_group_3_1.webp": "./src/assets/image/template/age_group_3_1.webp",
	"./template/age_group_3_2.webp": "./src/assets/image/template/age_group_3_2.webp",
	"./template/age_group_3_3.webp": "./src/assets/image/template/age_group_3_3.webp",
	"./template/age_group_3_4.webp": "./src/assets/image/template/age_group_3_4.webp",
	"./template/bodyCondition-image-1.png": "./src/assets/image/template/bodyCondition-image-1.png",
	"./template/bodyCondition-image-2.png": "./src/assets/image/template/bodyCondition-image-2.png",
	"./template/bodyCondition-image-3.png": "./src/assets/image/template/bodyCondition-image-3.png",
	"./template/bodyCondition-image-4.png": "./src/assets/image/template/bodyCondition-image-4.png",
	"./template/bodyCondition-image-5.png": "./src/assets/image/template/bodyCondition-image-5.png",
	"./template/bodyCondition-image-6.png": "./src/assets/image/template/bodyCondition-image-6.png",
	"./template/bodyCondition-image-7.png": "./src/assets/image/template/bodyCondition-image-7.png",
	"./template/bodyShape-1.png": "./src/assets/image/template/bodyShape-1.png",
	"./template/bodyShape-2.png": "./src/assets/image/template/bodyShape-2.png",
	"./template/bodyShape-3.png": "./src/assets/image/template/bodyShape-3.png",
	"./template/bodyShape-4.png": "./src/assets/image/template/bodyShape-4.png",
	"./template/bodyShape-5.png": "./src/assets/image/template/bodyShape-5.png",
	"./template/body_fat1.png": "./src/assets/image/template/body_fat1.png",
	"./template/body_fat2.png": "./src/assets/image/template/body_fat2.png",
	"./template/brainFog-image-1.png": "./src/assets/image/template/brainFog-image-1.png",
	"./template/brainFog-image-2.png": "./src/assets/image/template/brainFog-image-2.png",
	"./template/brainFog-image-3.png": "./src/assets/image/template/brainFog-image-3.png",
	"./template/brainFog-image-4.png": "./src/assets/image/template/brainFog-image-4.png",
	"./template/brainFogScreen-image-1.png": "./src/assets/image/template/brainFogScreen-image-1.png",
	"./template/brainFogScreen-image-2.png": "./src/assets/image/template/brainFogScreen-image-2.png",
	"./template/brainFogScreen-image-3.png": "./src/assets/image/template/brainFogScreen-image-3.png",
	"./template/brainFogScreen-image-4.png": "./src/assets/image/template/brainFogScreen-image-4.png",
	"./template/breathCondition-image-1.png": "./src/assets/image/template/breathCondition-image-1.png",
	"./template/breathCondition-image-2.png": "./src/assets/image/template/breathCondition-image-2.png",
	"./template/breathCondition-image-3.png": "./src/assets/image/template/breathCondition-image-3.png",
	"./template/breathCondition-image-4.png": "./src/assets/image/template/breathCondition-image-4.png",
	"./template/currentBody-image-1.png": "./src/assets/image/template/currentBody-image-1.png",
	"./template/currentBody-image-2.png": "./src/assets/image/template/currentBody-image-2.png",
	"./template/currentBody-image-3.png": "./src/assets/image/template/currentBody-image-3.png",
	"./template/currentBody-image-4.png": "./src/assets/image/template/currentBody-image-4.png",
	"./template/currentBody-image-5.png": "./src/assets/image/template/currentBody-image-5.png",
	"./template/currentBody-image-6.png": "./src/assets/image/template/currentBody-image-6.png",
	"./template/dietScreen-image-1.png": "./src/assets/image/template/dietScreen-image-1.png",
	"./template/dietScreen-image-2.png": "./src/assets/image/template/dietScreen-image-2.png",
	"./template/dietScreen-image-3.png": "./src/assets/image/template/dietScreen-image-3.png",
	"./template/dietScreen-image-4.png": "./src/assets/image/template/dietScreen-image-4.png",
	"./template/dietScreen-image-5.png": "./src/assets/image/template/dietScreen-image-5.png",
	"./template/energyLevel-image-1.png": "./src/assets/image/template/energyLevel-image-1.png",
	"./template/energyLevel-image-2.png": "./src/assets/image/template/energyLevel-image-2.png",
	"./template/energyLevel-image-3.png": "./src/assets/image/template/energyLevel-image-3.png",
	"./template/energyLevel-image-4.png": "./src/assets/image/template/energyLevel-image-4.png",
	"./template/event-image-1.png": "./src/assets/image/template/event-image-1.png",
	"./template/event-image-2.png": "./src/assets/image/template/event-image-2.png",
	"./template/event-image-3.png": "./src/assets/image/template/event-image-3.png",
	"./template/event-image-4.png": "./src/assets/image/template/event-image-4.png",
	"./template/event-image-5.png": "./src/assets/image/template/event-image-5.png",
	"./template/event-image-6.png": "./src/assets/image/template/event-image-6.png",
	"./template/event-image-7.png": "./src/assets/image/template/event-image-7.png",
	"./template/event-image-8.png": "./src/assets/image/template/event-image-8.png",
	"./template/eventScreen-image-1.png": "./src/assets/image/template/eventScreen-image-1.png",
	"./template/eventScreen-image-2.png": "./src/assets/image/template/eventScreen-image-2.png",
	"./template/eventScreen-image-3.png": "./src/assets/image/template/eventScreen-image-3.png",
	"./template/eventScreen-image-4.png": "./src/assets/image/template/eventScreen-image-4.png",
	"./template/eventScreen-image-5.png": "./src/assets/image/template/eventScreen-image-5.png",
	"./template/eventScreen-image-6.png": "./src/assets/image/template/eventScreen-image-6.png",
	"./template/eventScreen-image-7.png": "./src/assets/image/template/eventScreen-image-7.png",
	"./template/eventScreen-image-8.png": "./src/assets/image/template/eventScreen-image-8.png",
	"./template/exerciseFrequency-image-1.png": "./src/assets/image/template/exerciseFrequency-image-1.png",
	"./template/exerciseFrequency-image-2.png": "./src/assets/image/template/exerciseFrequency-image-2.png",
	"./template/exerciseFrequency-image-3.png": "./src/assets/image/template/exerciseFrequency-image-3.png",
	"./template/exerciseFrequency-image-4.png": "./src/assets/image/template/exerciseFrequency-image-4.png",
	"./template/familiarity-image-1.png": "./src/assets/image/template/familiarity-image-1.png",
	"./template/familiarity-image-2.png": "./src/assets/image/template/familiarity-image-2.png",
	"./template/familiarity-image-3.png": "./src/assets/image/template/familiarity-image-3.png",
	"./template/familiarity-image-4.png": "./src/assets/image/template/familiarity-image-4.png",
	"./template/feelBad-image-1.png": "./src/assets/image/template/feelBad-image-1.png",
	"./template/feelBad-image-2.png": "./src/assets/image/template/feelBad-image-2.png",
	"./template/feelBad-image-3.png": "./src/assets/image/template/feelBad-image-3.png",
	"./template/feelBad-image-4.png": "./src/assets/image/template/feelBad-image-4.png",
	"./template/feelBadScreen-image-1.png": "./src/assets/image/template/feelBadScreen-image-1.png",
	"./template/feelBadScreen-image-2.png": "./src/assets/image/template/feelBadScreen-image-2.png",
	"./template/feelBadScreen-image-3.png": "./src/assets/image/template/feelBadScreen-image-3.png",
	"./template/feelBadScreen-image-4.png": "./src/assets/image/template/feelBadScreen-image-4.png",
	"./template/fitness-image-1.png": "./src/assets/image/template/fitness-image-1.png",
	"./template/fitness-image-2.png": "./src/assets/image/template/fitness-image-2.png",
	"./template/fitness-image-3.png": "./src/assets/image/template/fitness-image-3.png",
	"./template/flexibilty-image-1.png": "./src/assets/image/template/flexibilty-image-1.png",
	"./template/flexibilty-image-2.png": "./src/assets/image/template/flexibilty-image-2.png",
	"./template/flexibilty-image-3.png": "./src/assets/image/template/flexibilty-image-3.png",
	"./template/focus-image-1.png": "./src/assets/image/template/focus-image-1.png",
	"./template/focus-image-2.png": "./src/assets/image/template/focus-image-2.png",
	"./template/focus-image-3.png": "./src/assets/image/template/focus-image-3.png",
	"./template/focus-image-4.png": "./src/assets/image/template/focus-image-4.png",
	"./template/focus-image-5.png": "./src/assets/image/template/focus-image-5.png",
	"./template/generationScreen-image.png": "./src/assets/image/template/generationScreen-image.png",
	"./template/happybody-image-1.png": "./src/assets/image/template/happybody-image-1.png",
	"./template/happybody-image-2.png": "./src/assets/image/template/happybody-image-2.png",
	"./template/happybody-image-3.png": "./src/assets/image/template/happybody-image-3.png",
	"./template/happybody-image-4.png": "./src/assets/image/template/happybody-image-4.png",
	"./template/happybody-image-5.png": "./src/assets/image/template/happybody-image-5.png",
	"./template/icon_star_light.png": "./src/assets/image/template/icon_star_light.png",
	"./template/img_video_first.png": "./src/assets/image/template/img_video_first.png",
	"./template/intro-image-1.png": "./src/assets/image/template/intro-image-1.png",
	"./template/intro-image-2.png": "./src/assets/image/template/intro-image-2.png",
	"./template/intro-image-3.png": "./src/assets/image/template/intro-image-3.png",
	"./template/intro-image-4.png": "./src/assets/image/template/intro-image-4.png",
	"./template/intro-image-5.png": "./src/assets/image/template/intro-image-5.png",
	"./template/intro-image-6.png": "./src/assets/image/template/intro-image-6.png",
	"./template/intro-image-7.png": "./src/assets/image/template/intro-image-7.png",
	"./template/intro-image-8.png": "./src/assets/image/template/intro-image-8.png",
	"./template/normal.png": "./src/assets/image/template/normal.png",
	"./template/normal1.png": "./src/assets/image/template/normal1.png",
	"./template/normal2.png": "./src/assets/image/template/normal2.png",
	"./template/obese.png": "./src/assets/image/template/obese.png",
	"./template/obese1.png": "./src/assets/image/template/obese1.png",
	"./template/obese2.png": "./src/assets/image/template/obese2.png",
	"./template/overweight.png": "./src/assets/image/template/overweight.png",
	"./template/overweight1.png": "./src/assets/image/template/overweight1.png",
	"./template/overweight2.png": "./src/assets/image/template/overweight2.png",
	"./template/painful-image-1.png": "./src/assets/image/template/painful-image-1.png",
	"./template/painful-image-2.png": "./src/assets/image/template/painful-image-2.png",
	"./template/painful-image-3.png": "./src/assets/image/template/painful-image-3.png",
	"./template/painful-image-4.png": "./src/assets/image/template/painful-image-4.png",
	"./template/painful-image-5.png": "./src/assets/image/template/painful-image-5.png",
	"./template/painful-image-6.png": "./src/assets/image/template/painful-image-6.png",
	"./template/painful-image-7.png": "./src/assets/image/template/painful-image-7.png",
	"./template/positive-image-1.png": "./src/assets/image/template/positive-image-1.png",
	"./template/positive-image-2.png": "./src/assets/image/template/positive-image-2.png",
	"./template/positive-image-3.png": "./src/assets/image/template/positive-image-3.png",
	"./template/positive-image-4.png": "./src/assets/image/template/positive-image-4.png",
	"./template/positive-image-5.png": "./src/assets/image/template/positive-image-5.png",
	"./template/positive-image-6.png": "./src/assets/image/template/positive-image-6.png",
	"./template/positive-image-7.png": "./src/assets/image/template/positive-image-7.png",
	"./template/positive-image-8.png": "./src/assets/image/template/positive-image-8.png",
	"./template/purpose-image-1.png": "./src/assets/image/template/purpose-image-1.png",
	"./template/purpose-image-2.png": "./src/assets/image/template/purpose-image-2.png",
	"./template/purpose-image-3.png": "./src/assets/image/template/purpose-image-3.png",
	"./template/purpose-image-4.png": "./src/assets/image/template/purpose-image-4.png",
	"./template/purpose-image-5.png": "./src/assets/image/template/purpose-image-5.png",
	"./template/sleepHourScreen-image.png": "./src/assets/image/template/sleepHourScreen-image.png",
	"./template/somatic-image-1.png": "./src/assets/image/template/somatic-image-1.png",
	"./template/somatic-image-2.png": "./src/assets/image/template/somatic-image-2.png",
	"./template/somatic-image-3.png": "./src/assets/image/template/somatic-image-3.png",
	"./template/specialNeed-image-1.png": "./src/assets/image/template/specialNeed-image-1.png",
	"./template/specialNeed-image-2.png": "./src/assets/image/template/specialNeed-image-2.png",
	"./template/specialNeed-image-3.png": "./src/assets/image/template/specialNeed-image-3.png",
	"./template/specialNeed-image-4.png": "./src/assets/image/template/specialNeed-image-4.png",
	"./template/specialNeed-image-5.png": "./src/assets/image/template/specialNeed-image-5.png",
	"./template/targetBody-image-1.png": "./src/assets/image/template/targetBody-image-1.png",
	"./template/targetBody-image-2.png": "./src/assets/image/template/targetBody-image-2.png",
	"./template/targetBody-image-3.png": "./src/assets/image/template/targetBody-image-3.png",
	"./template/targetBody-image-4.png": "./src/assets/image/template/targetBody-image-4.png",
	"./template/transition-mainimage-1.png": "./src/assets/image/template/transition-mainimage-1.png",
	"./template/transition-mainimage-2.png": "./src/assets/image/template/transition-mainimage-2.png",
	"./template/transition-mainimage-3.png": "./src/assets/image/template/transition-mainimage-3.png",
	"./template/typical-image-1.png": "./src/assets/image/template/typical-image-1.png",
	"./template/typical-image-2.png": "./src/assets/image/template/typical-image-2.png",
	"./template/typical-image-3.png": "./src/assets/image/template/typical-image-3.png",
	"./template/typicalDay-image-1.png": "./src/assets/image/template/typicalDay-image-1.png",
	"./template/typicalDay-image-2.png": "./src/assets/image/template/typicalDay-image-2.png",
	"./template/typicalDay-image-3.png": "./src/assets/image/template/typicalDay-image-3.png",
	"./template/underweight.png": "./src/assets/image/template/underweight.png",
	"./template/underweight1.png": "./src/assets/image/template/underweight1.png",
	"./template/underweight2.png": "./src/assets/image/template/underweight2.png",
	"./template/waterDrinkScreen-image-1.png": "./src/assets/image/template/waterDrinkScreen-image-1.png",
	"./template/waterDrinkScreen-image-2.png": "./src/assets/image/template/waterDrinkScreen-image-2.png",
	"./template/waterDrinkScreen-image-3.png": "./src/assets/image/template/waterDrinkScreen-image-3.png",
	"./template/waterDrinkScreen-image-4.png": "./src/assets/image/template/waterDrinkScreen-image-4.png",
	"./template/weight1.png": "./src/assets/image/template/weight1.png",
	"./template/weight2.png": "./src/assets/image/template/weight2.png",
	"./template/weight3.png": "./src/assets/image/template/weight3.png",
	"./template/workSchedule-image-1.png": "./src/assets/image/template/workSchedule-image-1.png",
	"./template/workSchedule-image-2.png": "./src/assets/image/template/workSchedule-image-2.png",
	"./template/workSchedule-image-3.png": "./src/assets/image/template/workSchedule-image-3.png",
	"./template/workSchedule-image-4.png": "./src/assets/image/template/workSchedule-image-4.png",
	"./template/yogaLevel-image-1.png": "./src/assets/image/template/yogaLevel-image-1.png",
	"./template/yogaLevel-image-2.png": "./src/assets/image/template/yogaLevel-image-2.png",
	"./template/yogaLevel-image-3.png": "./src/assets/image/template/yogaLevel-image-3.png",
	"./template/yogaLevel-image-4.png": "./src/assets/image/template/yogaLevel-image-4.png",
	"./theme/btn_bg_left.png": "./src/assets/image/theme/btn_bg_left.png",
	"./theme/btn_bg_right.png": "./src/assets/image/theme/btn_bg_right.png",
	"./theme/btn_icon1.png": "./src/assets/image/theme/btn_icon1.png",
	"./theme/btn_icon2.png": "./src/assets/image/theme/btn_icon2.png",
	"./theme/code-icon1.png": "./src/assets/image/theme/code-icon1.png",
	"./theme/code-icon2.png": "./src/assets/image/theme/code-icon2.png",
	"./theme/gift.png": "./src/assets/image/theme/gift.png",
	"./theme/h5_bg.png": "./src/assets/image/theme/h5_bg.png",
	"./theme/h5_text.png": "./src/assets/image/theme/h5_text.png",
	"./theme/logo.png": "./src/assets/image/theme/logo.png",
	"./theme/pc_bg.png": "./src/assets/image/theme/pc_bg.png",
	"./theme/pc_text.png": "./src/assets/image/theme/pc_text.png",
	"./theme/people_love_img.png": "./src/assets/image/theme/people_love_img.png",
	"./theme/plan_date.png": "./src/assets/image/theme/plan_date.png",
	"./theme/price_icon1.png": "./src/assets/image/theme/price_icon1.png",
	"./theme/price_icon2.png": "./src/assets/image/theme/price_icon2.png",
	"./theme/price_icon3.png": "./src/assets/image/theme/price_icon3.png",
	"./triangle.png": "./src/assets/image/triangle.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*$";